<template>
	<div class="content background1" style="display: flex">
		<div class="tableBox9" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table" style="overflow-x: scroll;">
					<tree :dataTree="treeData" @getDeviceMes="getDeviceMes" :exceptEq="1"></tree>
				</div>
			</div>
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0;">
					<div class="treeMes">
						<p class="title">{{$t('label_332')}} {{deviceTypeTitle}}
							<!-- <span style="float: right;font-weight: normal;font-size: 12px;color: #9EA5AD">2021/12/05 15:00:00</span> -->
						</p>
						<div class="buttonBox" style="justify-content: right">
							<div class="chooseButton sendButton" style="background: #30bc85;margin-right: 10px" @click="saveEqumentType"><i class="el-icon-receiving"></i>{{$t('btn_13')}}</div>
							<div class="chooseButton sendButton" style="margin-right: 15px" @click="comfrimEqumentType"><i class="el-icon-s-claim"></i>{{$t('btn_20')}}</div>
						</div>
						<div class="spotMes2Box" style="height: calc(100% - 90px);">
							<div class="spotMesBox" style="height:100%;">
								<el-tabs v-model="activeNameSpot" @tab-click="handleClickSpot">
									<el-tab-pane :label="$t('label_335')" name="spot" v-if="MenuRoleList.indexOf('9')>=0">
										<div class="tabMsss" style="height: 650px">
											<deviceParam ref="paramDisplay" :showButton="true" :needSort="true"></deviceParam>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_533')" name="pro" v-if="MenuRoleList.indexOf('13')>=0">
										<div class="tabMsss" style="height: 640px">
											<checkItem ref="checkItemDisplay" :showButton="true" :needSort="true"></checkItem>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_483')" name="bao" v-if="MenuRoleList.indexOf('17')>=0">
										<div class="tabMsss" style="height: 640px">
											<maintenanceItem ref="maintenanceItemDisplay" :showButton="true" :needSort="true"></maintenanceItem>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_143')" name="xun" v-if="MenuRoleList.indexOf('21')>=0">
										<div class="tabMsss" style="height: 640px">
											<inspectionItem ref="inspectionItemDisplay" :showButton="true" :needSort="true"></inspectionItem>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_338')" name="txt" v-if="MenuRoleList.indexOf('25')>=0">
										<div class="tabMsss" style="height: 640px">
											<electronDocument ref="electronDocumentItemDisplay" :showButton="true" :needSort="true"></electronDocument>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_119')" name="backup" v-if="MenuRoleList.indexOf('29')>=0">
										<div class="tabMsss" style="height: 640px">
											<partInfo ref="partInfoDisplay" :showButton="true" :needSort="true"></partInfo>
										</div>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_340')" name="position" v-if="MenuRoleList.indexOf('208')>=0">
										<div class="tabMsss" style="height: 640px">
											<position ref="positionDisplay" :showButton="true" :needSort="true"></position>
										</div>
									</el-tab-pane>
								</el-tabs>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import utils from '@/utils/utils'
	import tree from "@/components/list/tree/tree";
	import deviceParam from "@/components/list/displayPage/deviceParam";
	import checkItem from "@/components/list/displayPage/checkItem";
	import maintenanceItem from "@/components/list/displayPage/maintenanceItem";
	import inspectionItem from "@/components/list/displayPage/inspectionItem";
	import electronDocument from "@/components/list/displayPage/electronDocument";
	import partInfo from "@/components/list/displayPage/partInfo";
	import position from "@/components/list/displayPage/position";
	import file from "@/assets/js/file/file.js";

	export default {
		name: 'deviceTypePage',
		components: {
			Page,
			tree,
			deviceParam,
			maintenanceItem,
			inspectionItem,
			electronDocument,
			checkItem,
			partInfo,
			position,
		},
		data() {
			return {
				version: 2,
				pageNum: 1,
				select: 0,
				pageSize: 10,
				typeId: '',
				deviceTypeTitle: '',
				MenuRoleList: [],
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: false,
					funtoGetMes: '1'
				},
				pageCount: 0,
				activeNameSpot: 'spot',
				width: '340px',
				qrCodeShow: false,
			}
		},
		methods: {
			getIndex(index) {

			},
			checkUnitText(type) {
				var data = this.unitList.filter(function(item) {
					return item.key == type;
				});
				if (data != '') {
					return data[0].val
				}
			},
			handler() {

			},
			handleCurrentChangeAll(info) {},
			handleCurrentChangeDevice(info) {},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			tableDataTreeInfoEdit() {
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.dialogDeviceSpot = true;
					this.tableDataTreeEdit = this.tableDataTreeInfo
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			comfrimEqumentType() {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let param = {
					next: true,
					id: this.typeId
				}
				file.confirmEquipmentType(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						// console.log(data)
						loading.close();
						// utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						this.$message({
							message: data.message,
							type: 'success'
						});

					}
				}).catch((response) => {
					loading.close();
					console.log(response)
				})
			},
			saveEqumentType() {
				let param = {
					confirmStatus: '1',
					id: this.typeId
				}
				file.saveEquipmentTypeEdit(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						// utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						this.$message({
							message: data.message,
							type: 'success'
						});
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			saveEquipmentTypeEdit(param) {},
			handleCurrentChangeTreeTime(info) {},
			handleNodeClickDevice(data) {
				this.getTreeMes = '1';
			},
			handleClickSpot(tab, event) {
				//console.log(tab);
			},
			handleClickDevice(tab, event) {
				//console.log(tab, event);
			},
			searchPage(param) {
				var dataParam = this.searchDataList;
				var newParam = Object.assign(param, dataParam);
				this.tableParamDataPageNum = newParam.pageNum;
				this.tableParamDataPageSize = newParam.pageSize;
			},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				if (this.MenuRoleList.indexOf('9') >= 0) {
					this.$refs.paramDisplay.searchPage(param)
				}
				if (this.MenuRoleList.indexOf('13') >= 0) {
					this.$refs.checkItemDisplay.searchPage({
            pageNum: 1,
            pageSize: 50,
          })
				}
				if (this.MenuRoleList.indexOf('17') >= 0) {
					this.$refs.maintenanceItemDisplay.searchPage({
            pageNum: 1,
            pageSize: 50,
          })
				}
				if (this.MenuRoleList.indexOf('21') >= 0) {
					this.$refs.inspectionItemDisplay.searchPage(param)
				}
				if (this.MenuRoleList.indexOf('25') >= 0) {
					this.$refs.electronDocumentItemDisplay.searchPage(param)
				}
				if (this.MenuRoleList.indexOf('29') >= 0) {
					this.$refs.partInfoDisplay.searchPage(param)
				}
				if (this.MenuRoleList.indexOf('208') >= 0) {
					this.$refs.positionDisplay.searchPage(param)
				}
			},
			getDeviceMes(data) {
				this.$refs.paramDisplay.newMes(data.id)
				if (this.version != 1) {
					// this.$refs.checkItemDisplay.newMes(data.id)
					// this.$refs.maintenanceItemDisplay.newMes(data.id)
					// this.$refs.electronDocumentItemDisplay.newMes(data.id)
					// this.$refs.partInfoDisplay.newMes(data.id)
					// this.$refs.positionDisplay.newMes(data.id)
					// this.$refs.inspectionItemDisplay.newMes(data.id)
				if (this.MenuRoleList.indexOf('9') >= 0) {
					this.$refs.paramDisplay.newMes(data.id)
				}
				if (this.MenuRoleList.indexOf('13') >= 0) {
					this.$refs.checkItemDisplay.newMes(data.id)
				}
				if (this.MenuRoleList.indexOf('17') >= 0) {
					this.$refs.maintenanceItemDisplay.newMes(data.id)
				}
				if (this.MenuRoleList.indexOf('21') >= 0) {
					this.$refs.inspectionItemDisplay.newMes(data.id)
				}
				if (this.MenuRoleList.indexOf('25') >= 0) {
					this.$refs.electronDocumentItemDisplay.newMes(data.id)
				}
				if (this.MenuRoleList.indexOf('29') >= 0) {
					this.$refs.partInfoDisplay.newMes(data.id)
				}
				if (this.MenuRoleList.indexOf('208') >= 0) {
					this.$refs.positionDisplay.newMes(data.id)
				}
				}
				this.typeId = data.id;
				this.deviceTypeTitle = data.name;
				this.search();
			},
			changeSelectMonth() {
				this.tableDataTreeEdit.monthD = '';
				for (const k in this.monthOptions) {
					if (this.tableDataTreeEdit.month === this.monthOptions[k]) {
						this.monthDOptions = this.monthOptionsObj[this.tableDataTreeEdit.month]
					}
				}
			},
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
				} else {
					this.width = "340px";
				}
			},
		},
		created() {
			this.version = this.$store.getters.getVersions;
			this.MenuRoleList = this.$store.getters.getMenu;
		}
	}
</script>
<style>
	.right-showbtn-qrcode-background {
		/* position: absolute; */
		width: 10px;
		height: 80px;
		background-color: #9c9c9c;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		margin: auto;
	}
	
	.right-showbtn {
		width: 10px;
		height: 100%;
		display: flex;
		position: relative;
		z-index: 100000;
	}
</style>


// WEBPACK FOOTER //
// src/pages/file/deviceTypePage.vue